import { api } from "../../../api/api";
import {
  closeLoaderWithMessage,
  openLoaderWithMessage,
  showMessage,
} from "../../../redux/messages/messagesActions";
import {
  getFileExtensionFromUrl,
  getFileNameFromUrl,
} from "./getFileNameFromUrl";

export const downLoadFile = async (fileName: string | null) => {
  if (fileName) {
    const res = await api.post(
      "/general/download-files",
      {
        type: "",
        keys: [fileName],
      },
      {
        responseType: "arraybuffer",
      },
    );
    console.log(res);
    // const buffer = Buffer.from(res.data);
    const blob = new Blob([res.data], {
      type: "application/" + getFileExtensionFromUrl(fileName),
    });
    // const blob = new Blob([res.data], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);

    // Create a link element and simulate a click to trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", getFileNameFromUrl(fileName)); // Set the desired file name and extension
    document.body.appendChild(link);
    link.click();

    // Clean up by revoking the URL object
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }
  return null;
};

export const downLoadMultipleFiles = async (fileNames: string[] | null) => {
  if (fileNames && fileNames.length > 0) {
    for (const fileName of fileNames) {
      await downLoadFile(fileName);
    }
  }
};

export const downLoadBomExcelFile = async (data: {
  endpoint: string;
  dispatchWrapper: any;
  message?: string;
  bom_uuid?: string | null;
  routing_uuid?: string | null;
  order_no?: string | null;
  date?: {
    month?: string;
    year?: string;
    fromDate?: string;
    toDate?: string;
  };
  report_name: string;
  preview?: boolean;
  excel?: boolean;
  convert_to_inr?: boolean;
  formatCurrency?: boolean;
}) => {
  const {
    endpoint,
    dispatchWrapper,
    bom_uuid,
    routing_uuid,
    order_no,
    message,
    date,
    report_name,
    preview,
    excel,
    convert_to_inr = false,
    formatCurrency = false,
  } = data;
  console.log(date, endpoint, "date");

  if (bom_uuid || routing_uuid || order_no || date) {
    try {
      dispatchWrapper(
        openLoaderWithMessage(
          message || "Downloading Detailed Material Request...",
        ),
      );

      let searchQuery = "";

      if (order_no) {
        searchQuery = `?sod_no=${order_no}`;
      }
      if (bom_uuid) {
        searchQuery = `?bom_uuid=${bom_uuid}`;
      }
      if (routing_uuid) {
        searchQuery = `?routing_uuid=${routing_uuid}`;
      }
      if (date?.month || date?.year) {
        searchQuery = date.month
          ? `?month=${date.month}&year=${date.year}`
          : `?year=${date.year}`;
      }

      if (date?.fromDate && date?.toDate) {
        searchQuery += `?from_date=${date.fromDate}&to_date=${date.toDate}&excel=1`;
      }
      if (convert_to_inr) {
        searchQuery += `&convert_to_inr=true`;
      }

      if (endpoint === "/reports/get-order-processing-report") {
        searchQuery += `&formatCurrency=${formatCurrency === true ? 1 : 0}`;
      }
      const finalEndpoint = endpoint.includes("?")
        ? `${endpoint}${searchQuery.replace("?", "&")}`
        : `${endpoint}${searchQuery}`;

      const res = await api.get(finalEndpoint, {
        responseType: "arraybuffer",
      });

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      if (preview) {
        // For preview, return the blob
        dispatchWrapper(closeLoaderWithMessage());
        return blob;
      }

      // For download, trigger download as before
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${report_name}.xlsx`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error: any) {
      console.error("Error downloading the MR file:", error);
      dispatchWrapper(
        showMessage({
          displayAs: "snackbar",
          message: error.res?.data?.message || "Error downloading file",
          type: "error",
        }),
      );
    } finally {
      dispatchWrapper(closeLoaderWithMessage());
    }
  }
  return null;
};
